// extracted by mini-css-extract-plugin
module.exports = {"header":"BeigeHeader_header__tqRIK","hasCircles":"BeigeHeader_hasCircles__Eiay7","bg":"BeigeHeader_bg__V7oRc","container":"BeigeHeader_container__UJf3N"};